<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <span class="cookie_bar__text">This website uses cookies to improve the user experience</span>
                <button class="button--cta" @click="confirm">I understand</button>
                <button class="button--link">More information</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    //TODO style the cookie banner
    @Component
    export default class CookieBanner extends Vue {
        name = 'cookie-banner';

        confirm() {
            this.$emit('confirm');
        }
    }

    Vue.component('cookie-banner', CookieBanner);
</script>





// WEBPACK FOOTER //
// src/components/cookies/CookieBanner.vue